import type { HTMLChakraProps } from '@chakra-ui/react';
import { Box, Flex, Text } from '@chakra-ui/react';
import React from 'react';

import { CONTENT_MAX_WIDTH } from 'ui/shared/layout/utils';

const Footer = () => {
  const containerProps: HTMLChakraProps<'div'> = {
    backgroundImage: 'url("/Logo/footer.png")',
    backgroundSize: 'cover',
    px: { base: 10, lg: 5 },
    py: { base: 6, lg: 8 },
    as: 'footer',
    borderTopWidth: '1px',
    borderTopColor: 'blue.100',
    color: 'gray.800',
  };

  return (
    <Box { ...containerProps }>
      <Box
        px={{ base: 4, lg: 6 }}
        py={{ base: 4, lg: 8 }}
        maxW={ `${ CONTENT_MAX_WIDTH }px` }
        mx="auto"
      >
        <Flex alignItems="center">
          <a href="/">
            <img
              src="https://raw.githubusercontent.com/PhatIT2003/logo/main/vietscan1.svg"
              alt="VietScan Logo"
              style={{ width: '380px', height: '180px', objectFit: 'contain' }}
            />
          </a>
        </Flex>
        <Text mt={ 3 } fontSize="xs" color="gray.800">
          Vietscan is a Block Explorer and Analytics Platform for VietChain, a decentralized smart contracts platform.
        </Text>
      </Box>
    </Box>
  );
};

export default React.memo(Footer);
